import { useEffect, useState } from "react";
import { MessageCircle, Phone } from "lucide-react";
import { HOTEL } from "../data/site";

export default function FloatingActions() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="floating-action-buttons"
      className={`fixed z-40 bottom-5 right-5 sm:bottom-7 sm:right-7 flex flex-col gap-3 transition-all duration-500 ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <a
        href={HOTEL.whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Book on WhatsApp"
        data-testid="floating-whatsapp"
        className="relative h-14 w-14 rounded-full bg-[#25D366] text-white grid place-items-center shadow-xl shadow-[#25D366]/40 hover:scale-110 transition-transform"
      >
        <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" />
        <MessageCircle size={22} />
      </a>
      <a
        href={`tel:${HOTEL.phoneE164}`}
        aria-label="Call now"
        data-testid="floating-call"
        className="h-14 w-14 rounded-full bg-[#7A1A24] text-[#D4AF37] grid place-items-center shadow-xl shadow-[#7A1A24]/40 hover:scale-110 transition-transform"
      >
        <Phone size={20} />
      </a>
    </div>
  );
}
